// extracted by mini-css-extract-plugin
export default {"splitter":"Splitter_splitter__oTa4R","contentContainer":"Splitter_contentContainer__C4-xX","active":"Splitter_active__a4PWu"};